// A history item is an array containing two strings, path and text.
// This ensures that JSON.stringify produces the same string given the same history.
// (object property order isn't guaranteed).
function itemToJSON(item) {
  return JSON.stringify([item.path, item.text]);
}

function constructItem(raw, position, favorited) {
  return {
    path: raw[0],
    text: raw[1],
    position,
    favorited,
  };
}

function compareItem(first, second) {
  return first.text > second.text;
}

export function processHistoryResult(rawHistory) {
  const favorites = [];
  const recent = [];

  // History is stored in two lists: one for recent items and one for favorite items.
  // Store original position before sorting.
  rawHistory.favorites.forEach((item, i) => favorites.push(constructItem(item, i, true)));
  rawHistory.recent.forEach((item, i) => recent.push(constructItem(item, i, false)));

  favorites.sort(compareItem);
  recent.sort(compareItem);

  return favorites.concat(recent);
}

export function processFilterResult(rawFilters) {
  const filters = [];

  // History is stored in two lists: one for recent items and one for favorite items.
  // Store original position before sorting.
  rawFilters.filters.forEach((item, i) => filters.push(constructItem(item, i, true)));

  filters.sort(compareItem);

  return filters;
}

export function listHistory(userId, moduleName) {
  return {
    path: `employee/${userId}/history/${moduleName.toLowerCase()}`,
  };
}

export function clearHistory(userId, moduleName) {
  return {
    method: 'DELETE',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}`,
  };
}

export function clearRecentHistory(userId, moduleName) {
  return {
    method: 'DELETE',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/recent/all`,
  };
}

export function pushRecentHistoryItem(userId, moduleName, item) {
  return {
    method: 'POST',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/recent`,
    body: itemToJSON(item),
  };
}

export function deleteRecentHistoryItem(userId, moduleName, item) {
  return {
    method: 'DELETE',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/recent`,
    body: itemToJSON(item),
  };
}

export function favoriteHistoryItem(userId, moduleName, item) {
  return {
    method: 'POST',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/favorite`,
    body: itemToJSON(item),
  };
}

export function unfavoriteHistoryItem(userId, moduleName, item) {
  return {
    method: 'DELETE',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/favorite`,
    body: itemToJSON(item),
  };
}

export function getFilters(userId, searchTitle) {
  return {
    path: `employee/${userId}/history/${searchTitle.toLowerCase()}/filters`,
  };
}

export function favoriteFilters(userId, moduleName, item) {
  return {
    method: 'POST',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/filters`,
    body: JSON.stringify(item),
  };
}

export function unfavoriteFilters(userId, moduleName, item) {
  return {
    method: 'DELETE',
    path: `employee/${userId}/history/${moduleName.toLowerCase()}/filters`,
    body: JSON.stringify(item),
  };
}

export function getPreferences(userId) {
  return {
    path: `employee/${userId}/preferences`,
  };
}

// Merges `fields` into the stored preferences.
export function setPreferences(userId, fields) {
  return {
    method: 'PUT',
    path: `employee/${userId}/preferences`,
    body: JSON.stringify(fields),
  };
}
